import Quill from 'quill';

const Inline = Quill.import('blots/inline') as any;

class LinkBlot extends Inline {
  static blotName = 'link';
  static tagName = 'a';

  static create(value: string | { href: string; newTab?: boolean }) {
    const node = super.create();

    // Format URL to ensure it's absolute
    let url = typeof value === 'string' ? value : value.href;

    // Ensure URL has http/https prefix
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }

    // Set the href attribute
    node.setAttribute('href', url);

    // Always set target="_blank" regardless of input format
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer'); // Security best practice

    return node;
  }

  static formats(node: HTMLElement) {
    return node.getAttribute('href');
  }
}

export default LinkBlot;
